import { Subscription } from '@localstack/types';

export const getPeriodEnd = (s: Pick<Subscription, 'custom_renewal_date' | 'current_period_end'>): number =>
  s.custom_renewal_date ?? s.current_period_end;
